import styles from "./style.module.css";

import { Link } from "react-router-dom";
import { Box, Grid, Typography, Button } from "@mui/material";
import SwitchCell from "../../../../components/switch";
import EditIcon from "@mui/icons-material/Edit";
import Moment from "react-moment";
import { HasPermission } from "../../../../helper/helperFunction";
import AdminApi from "../../../../config/apis/admin";

const formatScore = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Number.isInteger(n) ? `${n}%` : `${n.toFixed(1)}%`;
};

const normalizeStringArray = (value) => {
  if (!Array.isArray(value)) return [];
  return value
    .map((v) => String(v || "").trim())
    .filter(Boolean);
};

const JobSingleCard = ({
  item,
  lg = 6,
  recommendation = null,
  aiEnabled = true,
  aiFiltersApplied = false,
}) => {
  const isRecommended = aiEnabled && !!recommendation;
  const isTopRecommended = recommendation?.is_top === true || recommendation?.rank === 1;
  const recommendationLabel =
    isTopRecommended && aiFiltersApplied ? "Top Recommended" : "Recommended";
  const scoreText = formatScore(recommendation?.final_score);
  const missingSkills = normalizeStringArray(recommendation?.missing_skills);
  const missingSkillsPreview = missingSkills.slice(0, 6);
  const missingSkillsExtraCount = Math.max(
    0,
    missingSkills.length - missingSkillsPreview.length
  );

  return (
    <Grid item xs={12} lg={lg} className={styles.col}>
      <Box className={styles.col_wrap}>
        <Link className={styles.Link} to={`/admin/jobs/view/${item.id}`}></Link>
        <Box display={"flex"} justifyContent={"space-between"}>
          <Box className={styles.titleWrap}>
            <Typography variant="h3">{item.job_title}</Typography>
            {isRecommended && isTopRecommended && (
              <span className={styles.topRecommendedTag}>
                {recommendationLabel}
              </span>
            )}
          </Box>

          <Box
            zIndex={1}
            display={"flex"}
            className={styles.edit_wrap}
            alignItems={"center"}
          >
            <HasPermission permission="manage-jobs-board.create">
              <SwitchCell
                EndPoint={AdminApi.JOBS_STATUS}
                id={item.id}
                is_active={item.job_status}
              />
              <Button>
                <Link to={`/admin/jobs/edit/${item.id}`}>
                  <EditIcon style={{ color: "#001C28", fontSize: 15 }} />
                </Link>
              </Button>
            </HasPermission>
          </Box>
        </Box>
        <Typography variant="h4">{item.company_name}</Typography>
        <Typography variant="p">{item.company_overview}</Typography>
        <Typography variant="h6">
          <span>Qualification</span> : {item.qualification_name}
        </Typography>

        {aiEnabled && !!recommendation && (
          <Box className={styles.aiMeta}>
            {scoreText && (
              <span className={styles.matchScoreTag}>{`Match: ${scoreText}`}</span>
            )}
            <Box className={styles.missingSkillsWrap}>
              <span className={styles.missingSkillsLabel}>Missing skills:</span>
              {missingSkillsPreview.length ? (
                <Box className={styles.missingSkillsList}>
                  {missingSkillsPreview.map((skill, idx) => (
                    <span
                      className={styles.skillPill}
                      key={`missing-${item.id}-${idx}-${skill}`}
                    >
                      {skill}
                    </span>
                  ))}
                  {missingSkillsExtraCount > 0 && (
                    <span className={styles.skillPill}>
                      +{missingSkillsExtraCount} more
                    </span>
                  )}
                </Box>
              ) : (
                <span className={styles.mutedValue}>-</span>
              )}
            </Box>
          </Box>
        )}

        <Box className={styles.small_box_wrap}>
          <Box className={styles.small_box}>
            <span className={styles.key}>{item.applicant_count}</span>
            <span className={styles.value}>Applicants</span>
          </Box>
          <Box className={styles.small_box}>
            <span className={styles.key}>{item.timings}</span>
            <span className={styles.value}>{item.job_type}</span>
          </Box>
          <Box className={styles.small_box}>
            <span className={styles.key}>Salary</span>
            <span className={styles.value}>
              {`${item.salary || "-"} ${item.currency}`}
            </span>
          </Box>
          <Box className={styles.small_box}>
            <span className={styles.key}>
              <Moment format="DD/MM/YYYY">{item.last_date_apply}</Moment>
            </span>
            <span className={styles.value}>Last Date</span>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default JobSingleCard;
